export default "__VITE_ASSET__CNAirJar__"